jQuery.validator.unobtrusive.adapters.add('requiredcheckbox', function(options) {

	if (!$(options.element).is(':checked')) {
		options.rules["required"] = true;
		if (options.message) {
			options.messages["required"] = options.message;
		}
	}
});

